import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PrlMarketingToolsComponent} from './components/prl-marketing-tools/prl-marketing-tools.component';
import {PrlMarketingToolsRoutingModule} from './prl-marketing-tools-routing.module';
import {MatCard, MatCardActions, MatCardContent} from '@angular/material/card';
import {MatFormField, MatLabel} from '@angular/material/input';
import {MatIconButton} from '@angular/material/button';
import {MatOption} from '@angular/material/core';
import {MatSelect} from '@angular/material/select';
import {
    MxButtonModule,
    MxDynamicFieldsModule,
    MxGridModule,
    MxInfoTooltipModule,
    MxPreloaderModule,
    MxSharedModule
} from 'mx-core';
import {PrlLanguageModule} from '../prl-language/prl-language.module';
import {PrlZonesComponent} from './components/prl-zones/prl-zones.component';
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {QRCodeComponent} from 'angularx-qrcode';
import {FormsModule} from '@angular/forms';

@NgModule({
  declarations: [PrlMarketingToolsComponent],
    imports: [
        CommonModule,
        FormsModule,
        MatCard,
        MatCardActions,
        MatCardContent,
        MatFormField,
        MatIconButton,
        MatLabel,
        MatOption,
        MatSelect,
        MxButtonModule,
        MxDynamicFieldsModule,
        MxInfoTooltipModule,
        MxPreloaderModule,
        MxSharedModule,
        MxGridModule,
        PrlLanguageModule,
        PrlMarketingToolsRoutingModule,
        PrlZonesComponent,
        MatSlideToggle,
        QRCodeComponent
    ]
})
export class PrlMarketingToolsModule {

}
